import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, Stethoscope, MapPin, ArrowUpRight } from 'lucide-react';

/**
 * Clinician-agnostic credential card used on Home + condition landing pages.
 * Reassures visitors they'll see a licensed PA-C or NP (never a chatbot) without
 * naming a specific provider — so copy scales as the practice hires more clinicians.
 */
const ClinicianCard = ({ variant = 'default' }) => {
  return (
    <section className={`clinician-card clinician-card-${variant}`} data-testid="clinician-card">
      <div className="clinician-card-inner">
        <div className="clinician-card-eyebrow">WHO WILL SEE YOU</div>
        <h3 className="clinician-card-title">
          A licensed clinician, <em>every single visit.</em>
        </h3>
        <p className="clinician-card-lede">
          Your care team is made up of board-certified PAs and Nurse Practitioners
          who specialize in women's hormone health. Never a chatbot. Never a rushed
          15 minute handoff.
        </p>

        <div className="clinician-card-creds">
          <div className="clinician-cred">
            <GraduationCap size={18} strokeWidth={1.5} />
            <div>
              <strong>Board Certified</strong>
              <span>PA-C or NP with masters-level training</span>
            </div>
          </div>
          <div className="clinician-cred">
            <Stethoscope size={18} strokeWidth={1.5} />
            <div>
              <strong>Women's Health Trained</strong>
              <span>Hormone, thyroid, and reproductive focus</span>
            </div>
          </div>
          <div className="clinician-cred">
            <MapPin size={18} strokeWidth={1.5} />
            <div>
              <strong>Licensed in Your State</strong>
              <span>Telehealth visits nationwide</span>
            </div>
          </div>
        </div>

        <Link to="/mystory" className="clinician-card-link" data-testid="clinician-card-link">
          Meet the team <ArrowUpRight size={16} />
        </Link>
      </div>
    </section>
  );
};

export default ClinicianCard;
